import { VueComponentUpload } from '@kvass/storage'
import { getDimensions } from '@/utils'
import { uploadOptions } from '@/components/Flatfinder/constants'
import { referenceDimensions, markByDimensions } from './dimensions'

const upload = (files, frames, onProgress = () => {}) => {
  const percents = files.map(() => 0)
  const report = index => value => {
    percents[index] = value
    onProgress(Math.round(percents.reduce((sum, percent) => sum + percent, 0) / (percents.length || 1)))
  }

  return Promise.all(files.map((file, index) => VueComponentUpload(file, report(index), uploadOptions)))
    .then(uploaded => uploaded.flat())
    .then(uploaded => Promise.all(uploaded.map(image => getDimensions(image.url).catch(() => {}))).then(() => uploaded))
    .then(uploaded => markByDimensions(uploaded, referenceDimensions(frames)))
}

export const pickFiles = ({ multiple = false } = {}) =>
  new Promise(resolve => {
    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = multiple
    input.accept = 'image/*'
    input.onchange = e => resolve(Array.from(e.target.files))
    input.oncancel = () => resolve([])
    input.click()
  })

export const uploadImages = (files, frames, onProgress = () => {}) =>
  upload(files, frames, onProgress)
    .then(({ images, rejected, reference }) => ({
      accepted: images.filter(Boolean),
      error: rejected ? { count: rejected, width: reference[0], height: reference[1] } : null,
    }))
    .catch(err => ({ accepted: [], error: { message: (err && err.message) || String(err) } }))
